// subdidy-details.component.ts

import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { saveAs } from 'file-saver';
import { MenuItem, MessageService } from 'primeng/api';
import { first } from 'rxjs/operators';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { DepartmentDashboardService } from 'src/app/services/department-dashboard.service';
import { JEService } from 'src/app/services/je-services.service';
import { ReportsService } from 'src/app/services/reports.service';
import { Table } from 'primeng/table';

@Component({
  selector: 'app-subdidy-details',
  templateUrl: './subdidy-details.component.html',
  styleUrls: ['./subdidy-details.component.scss'],
  providers: [MessageService],
})
export class SubdidyDetailsComponent implements OnInit {
  @ViewChild('miSurvey') miSurvey!: Table; // Correctly typed ViewChild
  @Output() mobilenumberEmit = new EventEmitter<string>();

  public subActionType: string = 'CompletedApps';
  public finYear: any;
  vendorCode: any;
  userType: any;
  public miTableData: any = [];
  public actionTypesFromTableData: any = [];
  public miCompletedFilterList: any = [];
  public subscriptions: any = [];
  public userId: any;
  public vendorRegId: any;
  public micada1Data: any = [];
  actionId: any = 18;
  public miTableDataWithFilter: any = [];
  public tableHeaderName = 'Subsidary Details';
  public miCompletedReport: MenuItem[] = [];
  public loading: boolean = false;
  public items: any[] = [];
  public selectedStatus: any;

  constructor(
    private reportsService: ReportsService,
    private deptDashBoardService: DepartmentDashboardService,
    private loader: AppLoaderService,
    private jeService: JEService,
    private activityRecordService: ActivityRecordService,
    private messageService: MessageService,
    private cryptoJsService: CryptoJsService,
    private router: Router
  ) { }

  ngOnInit(): void {
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userId = JSON.parse(payload)?.sub;

    this.finYear = 'All';
    this.loadSubsidaryDetails();

    this.miCompletedReport = [
      {
        label: 'Download Excel',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.exportExcel();
        },
      },
      // You can add more export options here if needed
    ];
  }


  exportExcel(): void {
    // Get the filtered data if a filter is applied; otherwise, use all data
    const modelData = this.miSurvey?.filteredValue || this.micada1Data || [];

    if (!modelData.length) {
      this.messageService.add({
        severity: 'info',
        summary: 'No Data',
        detail: 'No data available to export.',
      });
      return;
    }

    import('xlsx').then((xlsx) => {
      const dataToSave = modelData.map((d: any) => ({
        'APP ID': d.AppID,
        'Program Name': d.Program_Name,
        Amt: d.Amt,
        'Farmer Name': d.FarmerName,
        'Vendor Name': d.VendorName,
        District: d.District,
        Block: d.Block,
        Village: d.Village,
        PlantSpacing: d.PlantSpacing,
        RowSpacing: d.RowSpacing,
        MIArea: d.MIArea,
      }));

      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      });

      this.saveAsExcelFile(excelBuffer, `MI_${this.tableHeaderName}`);
    }).catch((error) => {
      console.error('Error importing xlsx:', error);
      this.messageService.add({
        severity: 'error',
        summary: 'Export Error',
        detail: 'An error occurred while exporting the data.',
      });
    });
  }


  saveAsExcelFile(buffer: any, fileName: string): void {
    const EXCEL_TYPE =
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    saveAs(data, `${fileName}_export_${new Date().getTime()}${EXCEL_EXTENSION}`);
  }

  loadSubsidaryDetails(): void {
    this.loader.start();
    this.deptDashBoardService
      .GetSubsidaryDetails(this.userId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();

          if (Array.isArray(data) && data.length > 0) {
            this.micada1Data = data;
          } else {
            this.micada1Data = [];
            this.messageService.add({
              severity: 'info',
              summary: 'No Data',
              detail: 'Data Not Found.',
            });
          }
        },
        error: (err) => {
          this.micada1Data = [];
          this.loader.close();
          
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: err?.message || 'An unexpected error occurred.',
          });
        },
      });
  }

  refreshTable() {
    this.loadSubsidaryDetails();
  }
}
